export default "__VITE_ASSET__2$183OCD__ 160w";